export default {
  endpoints: {
    email: '/auth/login',
    facebook: '/auth/facebook',
    microsoft: '/auth/microsoft',
    google: '/auth/google',
    apple: '/auth/apple',
    forgotPassword: '/auth/forgot-password'
  }
}
